import { useTranslation } from 'react-i18next';

interface LoginPageProps {
  /** True when they arrived here by signing out, rather than by opening the application. */
  disconnected?: boolean;
  onSignIn: () => void;
}

/**
 * Where somebody who is not signed in arrives. Deliberately a page with a button rather than an immediate
 * redirect to Microsoft: a shared link, a bookmark, or somebody checking whether this is the right application
 * all used to become a sign-in they had not asked for.
 */
export function LoginPage({ disconnected = false, onSignIn }: LoginPageProps) {
  const { t } = useTranslation();

  return (
    <div className="login-page">
      <div className="card login-card">
        <img src="/images/kersia_logo.svg" alt="Kersia" className="login-logo" />
        <h1 className="login-title">{t('app.name')}</h1>

        {/* Said before the invitation to sign in, because it is the reason they are looking at this page. */}
        {disconnected && (
          <p className="login-notice" role="status">
            <i className="pi pi-check-circle me-2" aria-hidden="true" />
            {t('app.disconnected')}
          </p>
        )}

        <p className="hint">{t('app.signInPrompt')}</p>

        <button type="button" className="btn btn-primary btn-lg login-button" onClick={onSignIn}>
          <i className="pi pi-microsoft me-2" aria-hidden="true" />
          {t('app.signInWithMicrosoft')}
        </button>
      </div>
    </div>
  );
}
